import styled from 'styled-components'
import { defaultTransition } from '../../theme'

export const InputContainer = styled.div<{ width?: number }>`
  ${({ width }) => (width ? `width: ${width}px;` : `width: 100%;`)}
  min-height: 44px;
  max-width: 3000px;
  background-clip: content-box;
  position: relative;
  box-sizing: border-box;
  background-position: right;
  background-size: cover;
  outline: none;

  @media screen and (max-width: 600px) {
    width: 100%;
  }
`

export const InputInner = styled.input<{
  width?: number
  noIcon: boolean
  cursor?: string
}>`
  ${({ width }) => (width ? `width: ${width}px;` : `width: calc(100% + 4px);`)}
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-left: ${({ noIcon }) => (noIcon ? 16 : 48)}px;
  height: 44px;
  padding-right: 16px;
  position: absolute;
  left: 0px;
  background: transparent;
  border: 1px solid var(--stroke-tertiary, #252525);
  background: var(--surface-invert-alpha-tertiary, rgba(0, 0, 0, 0.4));
  box-sizing: border-box;
  border-radius: 8px;
  outline: none;
  font-family: Space Grotesk;
  font-weight: 300;
  font-size: 16px;
  line-height: 20px;
  ::placeholder {
    opacity: ${({ theme: { isDark } }) => (isDark ? 0.3 : 0.8)};
  }
  :hover {
    cursor: ${(props) => props.cursor || 'pointer'};
  }
  :hover {
    border: 1px solid ${({ theme }) => theme.semantics.zap.stroke.secondary};
  }
  transition: border 0.3s ease-in-out;

  @media screen and (max-width: 600px) {
    box-sizing: border-box;
    border-radius: 4px;
    width: 100%;
  }
`
export const FakeInput = styled.div`
  width: calc(100% + 4px);
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-left: 16px;
  height: 44px;
  padding-right: 16px;
  position: absolute;
  top: 0;
  left: 0px;
  background: ${({ theme }) => theme.colors.textInputBg};
  transition: 0.3s ease-in-out;
  outline: none;
`

export const SearchIcon = styled.img`
  height: 16px;
  width: 16px;
  position: absolute;
  left: 20px;
  top: 50%;
  transform: translateY(-50%);
`
export const Text = styled.span`
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);

  font-family: 'Space Grotesk';
  font-size: 14px;
  line-height: normal;
  opacity: 0.4;
`
